$(function () {
    if ($(".page-template-template-contact-us .__textarea")[0]){
        $('.page-template-template-contact-us .__textarea:last').addClass('__right');
    }
});